import { render, staticRenderFns } from "./ISAForgot.vue?vue&type=template&id=3584c003&scoped=true&"
import script from "./ISAForgot.vue?vue&type=script&lang=js&"
export * from "./ISAForgot.vue?vue&type=script&lang=js&"
import style0 from "./ISAForgot.vue?vue&type=style&index=0&id=3584c003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584c003",
  null
  
)

export default component.exports